const colorsBg = [
  "bg-orange-200 text-orange-700",
  "bg-teal-200 text-teal-700",
  "bg-yellow-200 text-yellow-600",
  "bg-violet-200 text-violet-700",
  "bg-zinc-300 text-zinc-700",
  "bg-red-200 text-red-700",
  "bg-purple-200 text-purple-500",
  "bg-sky-200 text-sky-700",
  "bg-rose-200 text-rose-700",
  "bg-cyan-200 text-cyan-700",
  "bg-pink-200 text-pink-700",
  "bg-amber-200 text-amber-700",
];

const colorsTxt = [
  "text-purple-700",
  "text-amber-700",
  "text-emerald-700",
  "text-rose-700",
  "text-zinc-700",
  "text-blue-700",
  "text-lime-700",
  "text-orange-700",
  "text-yellow-700",
  "text-red-700",
  "text-cyan-700",
  "text-pink-700",
];

const colorTags = {
  slate: "bg-slate-300 border-slate-500 text-slate-700",
  blue: "bg-blue-300 border-cyan-500 text-cyan-700",
  sky: "bg-sky-200 border-sky-500 text-sky-700",
  yellow: "bg-orange-300 border-orange-500 text-orange-700",
  amber: "bg-amber-200 text-amber-600 text-amber-700",
  lime: "bg-lime-200 border-lime-500 text-lime-700",
  indigo: "bg-violet-300 border-violet-500 text-violet-700",
  pink: "bg-pink-300 border-pink-500 text-pink-700",
  rose: "bg-rose-200 border-rose-500 text-rose-700",
  gray: "bg-gray-300 border-gray-500 text-gray-700",
  stone: "bg-stone-300 border-stone-500 text-stone-700",
  neutral: "bg-neutral-300 border-neutral-500 text-neutral-700",
  black: "bg-neutral-700 border-neutral-800 text-neutral-100",
};

export { colorsBg, colorsTxt, colorTags };

export default { colorsBg, colorsTxt, colorTags };
